<template>
  <div>
    <div class="pa-1 mt-2 bordered rounded bg-grey_3" v-if="mainStore.module.activites.list.length > 0">
      <v-sheet color="darkblue text-h6 pa-2">Les activités: {{ mainStore.module.activites.total_inscriptions }} inscrits
        au total</v-sheet>
      <div class="pa-1 my-2 bg-white bordered rounded" v-for="activite in mainStore.module.activites.list"
        :key="activite.id">
        <div class="text-body-1 font-weight-bold">
          {{ activite.nom }}
        </div>

        <div class="d-flex sm-gap mb-2">
          <v-chip color="darkblue" size="large" density="compact" variant="elevated" elevation="0">{{
            activite.nb_inscrits }}<span v-if="activite.quantite > 0" class="mr-1">/{{ activite.quantite }}</span>
            inscrits</v-chip>
        </div>
        <v-progress-linear rounded :model-value="get_progress(activite.nb_inscrits, activite.quantite)" color="darkblue"
          height="6"></v-progress-linear>
      </div>
    </div>
    <div v-else>
      <v-sheet elevation="0" class="text-h6 pa-2">Ce module n'a pas d'activité</v-sheet>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";
export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    get_progress(nb, max) {
      if (max == 0) return 2;
      return (nb / max) * 100;
    },
  },
  async created() {
  },
};
</script>

<style lang="scss" scoped></style>